import fastDeepEqual from 'fast-deep-equal';
import { ImageSourcePropType } from 'react-native';

import { FastImageSource } from '../../../Image/FastImage';
import { CoverSourceType } from '../../types';

function isFastImageSource(
  source?: CoverSourceType
): source is FastImageSource {
  if (!source) {
    return false;
  }

  if (!(source as FastImageSource).uri) {
    return false;
  }

  return true;
}

function isResponsiveSource(source?: {
  [key: number]: ImageSourcePropType;
}): source is {
  [key: number]: ImageSourcePropType;
} {
  if (!source) {
    return false;
  }

  return true;
}

export const isCoverSourceSame: (
  prev?: CoverSourceType,
  next?: CoverSourceType
) => boolean = (prev, next) => {
  if (isFastImageSource(prev)) {
    return prev.uri === (next as any)?.uri;
  } else if (isResponsiveSource(prev)) {
    return fastDeepEqual(prev, next);
  }

  // check if defined
  return !!prev === !!next;
};
